import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import { AsyncWrapper } from '/src/components/common'
import { Loading } from '/src/components/loading'
import { useCartCount } from '/src/hooks/useCart'

const HeaderCartAsyncWrapper = () => {
  return (
    <AsyncWrapper>
      <HeaderCartDataWrapper />
    </AsyncWrapper>
  )
}

const HeaderCartDataWrapper = () => {
  const count = useCartCount()
  return <HeaderCart count={count} />
}

const HeaderCart = ({ count }) => {
  return (
    <>
      <FontAwesomeIcon icon={faCartShopping} />Cart
      {count === null && (
        <Loading />
      )}
      {count !== null && count !== false && (
        <span className="cart-count">{`(${count})`}</span>
      )}
    </>
  )
}

export default () => {
  return (
    <h5 className="m-0">
      <Link className="cart-link d-flex align-items-center justify-content-center" to="/cart">
        <HeaderCartAsyncWrapper />
      </Link>
    </h5>
  )
}
